import { render, staticRenderFns } from "./itemEmbalagem.vue?vue&type=template&id=178caaed"
import script from "./itemEmbalagem.ts?vue&type=script&lang=js&external"
export * from "./itemEmbalagem.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('178caaed')) {
      api.createRecord('178caaed', component.options)
    } else {
      api.reload('178caaed', component.options)
    }
    module.hot.accept("./itemEmbalagem.vue?vue&type=template&id=178caaed", function () {
      api.rerender('178caaed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/fracionaEstoque/itemEmbalagem.vue"
export default component.exports